/* Capitalize first letter of the string
 *  'test' -> 'Test'
 */
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/string_helper.js